angular.module('hjApp').service('Invoice', [
    '$q',
    'Restangular',
    'Notify',
    function ($q, Restangular, Notify) {
        /**
         * Get an unpaid invoice for the account. If the unpaid invoice is null or doesn't exist, we return a rejected
         * promise.
         *
         * @param {object} account The account to get an unpaid invoice for.
         * @param {number|null} account.unpaid_invoice The ID of the unpaid invoice.
         * @returns {Promise} The resolve query.
         */
        this.fetchUnpaid = function (account) {
            if (!account.unpaid_invoice) {
                return $q.reject();
            }

            var rInvoice = Restangular.one('accounts', account.id).one('invoices', account.unpaid_invoice);

            return rInvoice.get().catch(function (res) {
                Notify.error('Could not fetch invoice.');
                return $q.reject(res);
            });
        };

        /**
         * Update the PO # on a given Invoice.
         *
         * @param {object} account The account owning the invoice.
         * @param {number} account.id The account ID owning the invoice.
         * @param {object} invoice The invoice.
         * @param {number} invoice.id The invoice ID.
         * @param {string} po_number The updated PO Number.
         * @returns {Promise} The result of the update request.
         */
        this.updatePONumber = function (account, invoice, po_number) {
            var rInvoice = Restangular.one('accounts', account.id).one('invoices', invoice.id);
            return rInvoice.patch({
                po_number: po_number === '' || _.isUndefined(po_number) ? null : po_number
            });
        };
    }
]);
